import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { ActivatedRoute, RouterModule, RouterOutlet } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-try-now',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule, SpinnerComponent, NgxPaginationModule, SearchFilterPipe, RouterOutlet, NgSelectModule, RouterModule],
  templateUrl: './try-now.component.html'
})
export class TryNowComponent {
  //Common Variables
  pageName: string = ''
  searchText:string = ''
  p:number = 1
  userData:any

  // Email Panel Variables
  currentUser: any = null
  emailSubject: string = ''
  emailBody: string = ''
  emailLoading: boolean = false
  emailMessage: string = ''
  emailMessageType: 'success' | 'error' | '' = ''

  constructor(
    private readonly titleService: Title,
    private router: Router,
    private readonly commonService: CommonService,
    public formBuilder: FormBuilder,
    private readonly route: ActivatedRoute) {
    this.pageName = this.route.snapshot.data['name'];
  }

  ngOnInit(): void {
    this.getTryNowUsers()
    this.titleService.setTitle(`QMigrator - ${this.pageName}`);
  }

  onKey(){
    this.p = 1
  }

  getTryNowUsers(){
    this.commonService.getTryNowList().subscribe({
      next: (data: any) => {
        this.userData = data['jsonResponseData']['Table1'];
      },
      error: (error: any) => {
        console.error('Error fetching try now users:', error);
      }
    })
  }

  navigateTryNowView(obj: any): void {
    this.router.navigate(['tryNow-View'], { state: obj });
  }

  openEmailPanel(user: any): void {
    this.currentUser = user
    this.emailSubject = ''
    this.emailBody = ''
    this.emailMessage = ''
    this.emailMessageType = ''
  }

  closeEmailPanel(): void {
    this.currentUser = null
    this.emailSubject = ''
    this.emailBody = ''
    this.emailMessage = ''
    this.emailMessageType = ''
  }

  sendEmail(): void {
    if (!this.emailSubject.trim() || !this.emailBody.trim()) {
      this.emailMessage = 'Please fill in both subject and body'
      this.emailMessageType = 'error'
      return
    }

    this.emailLoading = true
    const emailData = {
      mailSubject: this.emailSubject,
      mailbody: this.emailBody,
      toMail: this.currentUser.email
    }

    this.commonService.sendSimpleMail(emailData).subscribe({
      next: (response: any) => {
        this.emailLoading = false
        if (response.status === 'Mail Sent') {
          this.emailMessage = 'Email sent successfully'
          this.emailMessageType = 'success'
          setTimeout(() => {
            this.closeEmailPanel()
          }, 1500)
        } else {
          this.emailMessage = response.message || 'Failed to send email'
          this.emailMessageType = 'error'
        }
      },
      error: (error: any) => {
        this.emailLoading = false
        this.emailMessage = 'Error sending email'
        this.emailMessageType = 'error'
        console.error('Error:', error)
      }
    })
  }
}
